import React from 'react'

import axios from 'axios';

const authenticate = async (setUser, navigate) => {
    console.log('in authenticate');
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/users/get`, { withCredentials: true });
        if (response.data && response.data.success) {
            const user = response.data.data.user;
            setUser(user);
            return user;
        }

        // Not successful
        setUser(null);
        if (navigate) navigate('/login', { state: { message: response?.data?.message } });
        return null;
    } catch (err) {
        console.log('authenticate error', err);
        setUser(null);
        if (navigate) navigate('/login', { state: { message: 'Please Login !' } });
        return null;
    }
};

export default authenticate;